import React from "react"
import "./App.css"
import { DNDProvider } from "./components/DND"
import MainLayout from "./containers/layout"

interface AppProps { }
const App: React.FC<AppProps> = (props) => {
    return (
        <DNDProvider>
            <MainLayout />
        </DNDProvider>
    )
}

export default App
